// Status-pill patroon naar het voorbeeld van sync-status-* (synchronisations.css).

/** Channel status → Dutch pill label. */
const STATUS_LABELS = {
    off: 'Uit',
    concept: 'Concept',
    live: 'Live',
    'action-needed': 'Actie nodig',
}

/**
 * @param {object} props
 * @param {string} props.status - 'off' | 'concept' | 'live' | 'action-needed'
 */
const StatusPill = ({ status }) => {

    return (
        <span className={`impact-channel-status impact-channel-status--${status}`}>
            {STATUS_LABELS[status] || status}
        </span>
    )
}

export default StatusPill
